import {
  AREA,
  AUTOCOMPLETE,
  AUTOCOMPLETE_AREA,
  DATE_PICKER,
  NUMBER,
  SELECT,
} from "../../../constants/fields";
import { FieldConfig } from "../../common/forms/Interfaces";

const oneLine = {
  labelCol: {
    xs: { span: 24 },
    sm: { span: 8 },
  },
  wrapperCol: {
    xs: { span: 24 },
    sm: { span: 16 },
  },
};

const config = {
  cmr_number: {
    label: "Cmr Number",
    placeholder: "Enter cmr number",
    extra: oneLine,
  },
  department_id: {
    type: SELECT,
    label: "Department",
    placeholder: "Select department",
    extra: oneLine,
    allowClear: true,
  },
  user_id: {
    type: SELECT,
    label: "Client",
    placeholder: "Select client",
    extra: oneLine,
    allowClear: true,
  },

  // #1
  consignor: {
    type: AUTOCOMPLETE,
    label: "Name",
    placeholder: "Enter name of sender",
    extra: oneLine,
  },
  consignor_address: {
    type: AUTOCOMPLETE,
    label: "Address",
    placeholder: "Enter address of sender",
    extra: oneLine,
  },
  consignor_country: {
    type: SELECT,
    showSearch: true,
    label: "Country",
    placeholder: "Enter country of sender",
    extra: oneLine,
  },
  consignor_note: {
    type: AUTOCOMPLETE,
    label: "Note",
    placeholder: "Enter note",
    extra: oneLine,
  },

  // #2
  consignee: {
    type: AUTOCOMPLETE,
    label: "Name",
    placeholder: "Enter name of consignee",
    extra: oneLine,
  },
  consignee_address: {
    type: AUTOCOMPLETE,
    label: "Address",
    placeholder: "Enter address of consignee",
    extra: oneLine,
  },
  consignee_country: {
    type: SELECT,
    showSearch: true,
    label: "Country",
    placeholder: "Enter country of consignee",
    extra: oneLine,
  },
  consignee_note: {
    type: AUTOCOMPLETE,
    label: "Note",
    placeholder: "Enter note",
    extra: oneLine,
  },

  // #3
  unloading_place: {
    type: AUTOCOMPLETE,
    label: "Place",
    placeholder: "Enter place of delivery of the goods",
    extra: oneLine,
  },
  unloading_country: {
    type: SELECT,
    showSearch: true,
    label: "Country",
    placeholder: "Select country of delivery of the goods!",
    extra: oneLine,
  },

  // #4
  loading_place: {
    type: AUTOCOMPLETE,
    label: "Place",
    placeholder: "Enter place of taking over the goods",
    extra: oneLine,
  },
  loading_country: {
    type: SELECT,
    showSearch: true,
    label: "Country",
    placeholder: "Select country of taking over the goods",
    extra: oneLine,
  },
  loading_date: {
    type: DATE_PICKER,
    label: "Date",
    placeholder: "Enter date of taking over the goods",
    extra: oneLine,
  },

  // #5
  invoice: {
    type: AUTOCOMPLETE,
    label: "Invoice(s)",
    placeholder: "Enter invoice(s)",
    extra: oneLine,
  },
  documents: {
    type: AREA,
    placeholder: "Enter documents attached",
    className: "textarea-height",
  },

  // #6,7,8,9
  cargo: {
    type: AUTOCOMPLETE_AREA,
    placeholder:
      "Enter Marks and Nos, Number of pakages, Method of packing, Nature of the goods",
  },
  total: {
    type: NUMBER,
    label: "Total",
    placeholder: "Enter total (CCL)",
    extra: oneLine,
  },
  class: {
    type: AUTOCOMPLETE,
    label: "Class",
    extra: oneLine,
    placeholder: "Enter Class",
  },
  digit: {
    type: AUTOCOMPLETE,
    label: "Number",
    extra: oneLine,
    placeholder: "Enter Number",
  },
  letter: {
    type: AUTOCOMPLETE,
    label: "PG",
    extra: oneLine,
    placeholder: "Enter PG",
  },
  additional_address: {
    type: AUTOCOMPLETE,
    label: "(ADR*)",
    extra: oneLine,
    placeholder: "Enter ADR*",
  },

  // #10
  statistic_number: {
    type: AUTOCOMPLETE,
    placeholder: "Enter statistical number",
  },

  // #11
  brutto: {
    type: AUTOCOMPLETE,
    placeholder: "Enter gross weight in kg",
  },

  // #12
  volume: {
    type: NUMBER,
    placeholder: "Enter volume in m3",
  },

  // #13
  destination_customs: {
    type: AUTOCOMPLETE,
    label: "Destination customs",
    placeholder: "Enter destination customs",
    extra: oneLine,
  },
  consignor_instructions: {
    type: AUTOCOMPLETE,
    placeholder: "Enter sender's instructions",
  },

  // #14
  terms_of_payment: {
    type: AUTOCOMPLETE,
    placeholder: "Enter instruction as to payment carriage",
  },
  carriage_paid: {
    type: AUTOCOMPLETE,
    label: "Carriage paid",
    placeholder: "Enter carriage paid",
    extra: oneLine,
  },
  carriage_unpaid: {
    type: AUTOCOMPLETE,
    label: "Carriage forward",
    placeholder: "Enter carriage unpaid",
    extra: oneLine,
  },

  // #15
  cash_on_delivery: {
    type: AUTOCOMPLETE,
    label: "Cash on delivery",
    placeholder: "Enter cash on delivery",
    extra: oneLine,
  },

  // #16
  carrier: {
    type: AUTOCOMPLETE,
    label: "Name",
    placeholder: "Enter name of carrier",
    extra: oneLine,
  },
  carrier_address: {
    type: AUTOCOMPLETE,
    label: "Address",
    placeholder: "Enter address of carrier",
    extra: oneLine,
  },
  carrier_country: {
    type: SELECT,
    showSearch: true,
    label: "Country",
    placeholder: "Enter country of carrier",
    extra: oneLine,
  },
  carrier_truck_number: {
    type: AUTOCOMPLETE,
    label: "Truck Number",
    placeholder: "Enter truck number",
    extra: oneLine,
  },

  // #17
  next_carrier: {
    type: AUTOCOMPLETE,
    label: "Name",
    placeholder: "Enter name of succesive carrier",
    extra: oneLine,
  },
  next_carrier_address: {
    type: AUTOCOMPLETE,
    label: "Address",
    placeholder: "Enter address of succesive carrier",
    extra: oneLine,
  },
  next_carrier_country: {
    type: SELECT,
    showSearch: true,
    label: "Country",
    placeholder: "Enter country of succesive carrier",
    extra: oneLine,
  },
  next_truck_number: {
    type: AUTOCOMPLETE,
    label: "Truck Number",
    placeholder: "Enter truck number",
    extra: oneLine,
  },

  // #18
  comments_of_carrier: {
    type: AUTOCOMPLETE,
    placeholder: "Enter carrier's reservations and observations",
  },

  // #19
  special_agreements: {
    type: AUTOCOMPLETE,
    placeholder: "Enter special agreements",
  },

  // #21
  cmr_place: {
    type: AUTOCOMPLETE,
    label: "Established in",
    placeholder: "Enter place of CMR",
    extra: oneLine,
  },
  cmr_date: {
    type: DATE_PICKER,
    label: "on",
    extra: oneLine,
  },

  // #22
  sender_signature_and_stamp: {
    type: AUTOCOMPLETE,
    label: "Signature and stamp of the sender",
    placeholder: "Enter signature and stamp of the sender",
  },
} as { [key: string]: FieldConfig };

export default config;
